import React, { useRef } from "react";
import { Box, Checkbox, Chip, ClickAwayListener, Grid, IconButton, InputAdornment, List, ListItem, ListItemText, ListSubheader, Popover, Popper, Stack, TextField, Tooltip, styled as MUIStyled, TooltipProps, tooltipClasses } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import './style.css'
import { COLOR_MAP } from "../../../../constants/ColorNames";
import styled from "@emotion/styled";
import { setErrorMessages, setJobLocation, setJobMode } from "../../../../redux/slice/campaignSlice";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import SingleSelectDropDown from "../../../../common/components/SingleSelectDropDown";
import { useGetDraftDataQuery, useGetSearchDataQuery } from "../../../../redux/services/folderName";
import { filterObject } from "../../../../utils/helpers";
import CommonTooltip from "../../../../common/components/CommonTooltip";
import ChipDelete from "../../../../constants/icons/ChipDelete";
import ChevronRight from "../../../../constants/icons/ChevronRight";

const StyledInputAdornment =  styled(InputAdornment)`
  flex-wrap: wrap;
  flex-direction: column;
  height: auto;
  margin: 0;
  gap: 0.4rem;
  padding: 1.2rem 0;
  width: auto;
  > span{
    display: none;
  }
  .MuiChip-root {
    width: auto;
  }
  .MuiChip-label {
    padding-left: 0.8rem;
    padding-right: 0.4rem;
  }
  .MuiSvgIcon-root{
    margin: 0 0.5rem 0 0 !important;
  }

`;

const StyledIconButton = styled(IconButton)`
  display: none;
`

const StyledParentListItems = styled(ListItem)`
  cursor: pointer;
  padding: 4px 12px 4px 12px !important;
  &:hover {
    background: linear-gradient(0deg, #E7E7EA, #E7E7EA),
                linear-gradient(0deg, #FFFFFF, #FFFFFF);
    button {
      display: block;
    }
  }
`; 

const LocationDropdownBox = styled(Box)`
  cursor: pointer;
  border-radius: 4px 0px 0px 4px;
  border-right: 1px solid #D2D1D6;
  background: #F6F6F7;
  display: flex;
  padding: 0px 12px;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  color: #59566C;
`
const BootstrapTooltip = MUIStyled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  }
}));

type JobLocationProps = {
  showError?: boolean,
  errorMessage?: string,
  OPTIONS_LIST: any[]
}

const updateItemStates = (
  oldState: any[], items: any[], clickedId: any, pillData: any[]
) => {
  const newState = oldState.map((i) => ({ ...i }));
  // getters
  const getItemState = (id: number) => {
    return newState.find((i) => i.id === id)?.isChecked;
  };
  // setters
  const updateparentId = (id: number) => {
    const item = items.find((i) => i.id === id);
    const parentId = items.find((i) => i.id === item.parentId);
    if (!parentId) return;
    const childIds = items.filter((i) => i.parentId === parentId.id).map((i) => i.id);
    const childStates = childIds.map((childId) => getItemState(childId));
    let parentData = newState.find((i) => i.id === parentId.id)
    if (childStates.some((s) => s === true)) {

      parentData.isChecked = true;
      //parentData.selected = parentData.count
    } else {
      parentData.isChecked = false;
      //parentData.selected = +parentData.count - childStates.length
    }
    updateparentId(parentId.id);
  };

  const setUnchecked = (id: number) => {

    let selectedData = newState.find((i) => i.id === id)
    selectedData.isChecked = false;

    //  let selectedDataParent = newState.find((i) => i.id === selectedData.parentId)
    //  if(selectedDataParent?.isChecked){
    //   selectedDataParent.isChecked = false
    //  }

    items
      .filter((i) => i.parentId === id)
      .map((i) => i.id)
      .forEach((childId) => setUnchecked(childId));

  };
  const setChecked = (id: number) => {
    let selectedData = newState.find((i) => i.id === id)
    selectedData.isChecked = true;
    // items
    //   .filter((i) => i.parentId === id)
    //   .map((i) => i.id)
    //   .forEach((childId) => setChecked(childId));

  };

  // actual logic
  let checkedState = true
  const itemState = getItemState(clickedId);
  if (itemState) {
    setUnchecked(clickedId);
    checkedState = false
  } else {
    setChecked(clickedId);
  }
  let updateCount = newState.find((i) => i.id === clickedId)
  const selectedData = items.find((i) => i.id === clickedId)
  if (selectedData.parentId === 0 || selectedData.next) {

    if (checkedState) {
      updateCount.selected = selectedData.count
    }
    else {
      updateCount.selected = 0
    }

  }
  else {
    updateCount = newState.find((i) => i.id === updateCount.parentId)
    if (checkedState) {
      updateCount.selected = updateCount.selected + 1
    }
    else {
      updateCount.selected = updateCount.selected - 1
    }
  }
  if (updateCount.selected === 0) {
    updateCount.isChecked = false
  }
  else if (updateCount.selected === selectedData.count) {
    updateCount.isChecked = true
  }


  let updatedPillState = [...pillData]
  const selectItemParentData = items.find((i) => i.id === selectedData.parentId)
  if (selectedData.isPillData) {
    if (checkedState) {
      updatedPillState = updatedPillState.filter((pill: any) => pill.label !== selectedData.label)
      updatedPillState.push({
        label: selectedData.label,
        id: [selectedData.id],
        parentId: selectedData.parentId
      })
    }
    else {
      updatedPillState = updatedPillState.filter((pill: any) => pill.label !== selectedData.label)
    }

  } else if (selectedData.parentId !== 0 && selectItemParentData.isPillData) {
    if (checkedState) {
      updatedPillState = updatedPillState.filter((pill: any) => pill.parentId !== selectedData.id)

      let childIds = items.filter((item: any) => item.parentId === selectedData.id).map((item: any) => item.id)
      updatedPillState.push({
        parentId: selectedData.id,
        label: selectedData.label,
        id: [...childIds]
      })
    }
    else {
      updatedPillState = updatedPillState.filter((pill: any) => pill.parentId !== selectedData.id)
    }
  }
  else {
    const childrenData = items.filter((item: any) => item.parentId === selectedData.id)
    if (checkedState) {
      updatedPillState = updatedPillState.filter((pill: any) => pill.parentId !== selectedData.id)
      childrenData.forEach((child: any) => {
        updatedPillState.push({
          label: child.label,
          id: [child.id],
          parentId: selectedData.id

        })
      })
    }
    else {
      updatedPillState = updatedPillState.filter((pill: any) => pill.parentId !== selectedData.id)
    }
  }
  return [newState, updatedPillState];
};

const updateManyItemStates = (oldState: any[], items: any[], clickedId: any[], pillData: any[], checked: any) => {
  const newState = oldState.map((i) => ({ ...i }));
  // getters
  const getItemState = (id: number) => {
    return newState.find((i) => i.id === id).isChecked;
  };
  // setters
  const updateparentId = (id: number) => {
    const item = items.find((i) => i.id === id);
    const parentId = items.find((i) => i.id === item.parentId);
    if (!parentId) return;
    const childIds = items.filter((i) => i.parentId === parentId.id).map((i) => i.id);
    const childStates = childIds.map((childId) => getItemState(childId));
    let parentData = newState.find((i) => i.id === parentId.id)
    if (childStates.length === childStates.filter((s) => s === true).length) {

      parentData.isChecked = true;
      //parentData.selected = parentData.count
    } else {
      parentData.isChecked = false;
      //parentData.selected = +parentData.count - childStates.length
    }
    updateparentId(parentId.id);
  };

  const setCheckedValue = (id: number) => {
    items
      .filter((i) => i.parentId === id)
      .map((i) => i.id)
      .forEach((childId) => setCheckedValue(childId));
    updateparentId(id);
  };
  let parentId = 0;
  newState.filter((i) => clickedId.includes(i.id)).forEach(item => {
    item.isChecked = checked
    parentId = item.parentId
  })
  setCheckedValue(clickedId[0])
  const newPillStates = [...pillData]

  let parentLabel = items.find((item: any) => item.id === parentId)?.label
  let pillIndex = newPillStates.findIndex((pill) => pill.parentId === parentId)
  if (pillIndex > -1) {
    if (checked) {
      newPillStates[pillIndex].id = [...clickedId]
      newPillStates[pillIndex].label = 'updated label'
    }
    else {
      newPillStates.splice(pillIndex, 1)
    }


  }
  else {
    newPillStates.push({
      label: parentLabel,
      id: [...clickedId],
      parentId: parentId
    })
  }
  return [newState, newPillStates];
};



const SelectedLocations = ({ data, handlePillDelete, reference, disabled }: any) => {
  const [visiblePills, setVisiblePills] = useState<any>([]);
  const [moreCount, setMoreCount] = useState(0);

  useEffect(() => {
    const calculateVisiblePills = () => {
      let totalWidth = 0;
      let tempVisiblePills: any[] = [];
      let overflowCount = 0;
      const inputWidth = reference.current ? reference.current.offsetWidth : 0;

      data.forEach((pill: any, index: number) => {
        //below calculation is for the chip width. each letter takes appx. 7px and 39px is accounting the rest, like padding
        const pillWidth = 45 + (7 * pill?.label?.length);
        if (totalWidth + pillWidth <= inputWidth) {
          tempVisiblePills.push(pill);
          totalWidth += pillWidth;
        } else {
          overflowCount++;
        }
      });

      if (overflowCount && tempVisiblePills.length - 1 && (totalWidth + 59 > inputWidth)) {
        overflowCount++
        tempVisiblePills.pop()
      }
      setVisiblePills(tempVisiblePills);
      setMoreCount(overflowCount);
    }

    calculateVisiblePills();
  }, [data, reference]);

  const visibleListLabel = visiblePills?.map((j: any) => j?.label)
  return (
    <>
      {visiblePills.map((pill: any, index: any) => (
        <Chip key={index} label={pill.label} onDelete={() => {
          if (disabled) {
            return
          } else {
            handlePillDelete(pill)
          }
        }}
          sx={{
            "&.MuiChip-root": {
              backgroundColor: disabled ? '#FFF' : '#EAECFF',
              border: disabled ? '1px solid #E8E8EB' : '1px solid #D7D9EB',
              color: disabled ? '#D2D1D6' : '#17142A',
              padding: '6px 12px',

            },
            "& .MuiChip-label": {
              paddingLeft: '0 !important'
            }
          }}
          deleteIcon={
            <span
              style={{
                display: 'flex',
                cursor: disabled ? 'default' : 'pointer'
              }}
              onClick={() => {
                if (disabled) {
                  return
                } else {
                  handlePillDelete(pill)
                }
              }}>
              <ChipDelete fill={disabled ? "#D2D1D6" : "#17142A"} />
            </span>}
        />
      ))}
      {moreCount > 0 && (
        <BootstrapTooltip title={
          <div style={{ fontSize: '12px', lineHeight: '16px', padding: '12px' }}>
            {data.filter((i: { label: any; }) => !visibleListLabel?.includes(i?.label)).map((i: any) => i.label).join(", ")}
          </div>
        }>
          <Chip sx={{
            zIndex: 1,
            "&.MuiChip-root": {
              backgroundColor: disabled ? '#FFF' : '#EAECFF',
              border: disabled ? '1px solid #E8E8EB' : '1px solid #D7D9EB',
              color: disabled ? '#D2D1D6' : '#17142A',
              padding: '6px 12px',

            },
            "& .MuiChip-label": {
              paddingLeft: '0 !important'
            }
          }} label={`${moreCount} More`}
            deleteIcon={<ChevronRight fill={disabled ? "#D2D1D6" : "#17142A"} />} onDelete={() => { }}
          />
        </BootstrapTooltip>
      )}
    </>
  );
};


const JobLocation = (props: JobLocationProps) => {
  const { OPTIONS_LIST, showError, errorMessage } = props
  const dispatch = useDispatch();
  const jobLocation = useSelector((state: RootState) => state.campaign.jobLocation);
  const jobMode = useSelector((state: RootState) => state.campaign.jobMode)
  const errorMessages = useSelector((state: RootState) => state.campaign.errorMessages);

  const [inputValue, setInputValue] = useState('')
  const [itemStates, setItemStates] = useState<any[]>([]);
  const [copyItemStates, setCopyItemState] = useState<any[]>([])
  const [pillData, setPillData] = useState<any[]>([])
  const [currentSelectedParent, setCurrentSelectParent] = useState<any>('topCities')
  const [open, setOpen] = useState(false);
  const refInp = useRef() as React.MutableRefObject<HTMLInputElement>
  const [locationTypeMenu, setLocationTypeMenu] = useState<boolean>(false)
  const [preloadedDataFilled, setPreloadedDataFilled] = useState<boolean>(false)

  const urlParams = new URLSearchParams(window.location.search);
  const campaignId = urlParams.get('campaignId');
  const initiationId = urlParams.get('initiationId');
  const { data: draftData } = useGetDraftDataQuery(campaignId, { skip: !campaignId })
  const { data: searchData } = useGetSearchDataQuery(initiationId, { skip: !!campaignId })

  const isDisabled = (jobMode === 'Remote') || (pillData && pillData.length >= 5) ? true : false;
  const triggeredFromPage = useSelector((state: RootState) => state.campaign.campaignCreationQueryData.triggeredFromPage);
  const location = useSelector(
    (state: RootState) => state.campaign.disabledFields.jobLocations
  );
  const disableJobLocation = ((triggeredFromPage === 'SRP' && location)) ? true : false

  useEffect(() => {
    let checkboxStates = OPTIONS_LIST.map((option: any) => {
      return {
        selected: 0,
        isChecked: false,
        parentId: option.parentId,
        id: option.id
      }
    })
    setItemStates([...checkboxStates])
    setCopyItemState([...checkboxStates])
  }, [OPTIONS_LIST])

  const preloadedData = draftData?.campaignJobDescription?.jobLocations || searchData?.jobLocations

  useEffect(() => {
    // Handle preloadedData
    if (filterObject(preloadedData) && !preloadedDataFilled && copyItemStates.length > 0) {
      let updatedItemStates = [...itemStates];
      let updatedPillData = [...pillData];
      let changesMade = false;

      preloadedData?.forEach((location: any) => {
        const locationId = OPTIONS_LIST.find(i => i.label === location)?.id;
        if (locationId) {
          const [tempItemStates, tempPillData] = updateItemStates(updatedItemStates, OPTIONS_LIST, locationId, updatedPillData);
          if (tempPillData.length <= 5) {
            updatedItemStates = tempItemStates;
            updatedPillData = tempPillData;
            changesMade = true;
          }
        }
      });

      if (changesMade) {
        setItemStates(updatedItemStates);
        setCopyItemState(updatedItemStates);
        setPillData(updatedPillData);
        setCurrentSelectParent('topCities');
        setInputValue('');
        setPreloadedDataFilled(true);
      }
    }
    // Handle pillData changes
    else {
      if (!pillData || !pillData.length) return;
      const locationsArray = pillData.map((item) => item.label);
      dispatch(setJobLocation({ jobLocation: locationsArray }));
      if (errorMessages?.jobLocation) {
        dispatch(setErrorMessages({ errorMessages: { jobLocation: '' } }));
      }
    }

  }, [pillData, preloadedData, preloadedDataFilled, dispatch, OPTIONS_LIST, itemStates, copyItemStates]);

  const handleInputChange = (text: string) => {
    setInputValue(text);

    if (!text && currentSelectedParent !== 'topCities') {
      setCurrentSelectParent('topCities')
    }

    let filterData = OPTIONS_LIST.filter(opt => (opt.label.toLowerCase().includes(text.toLowerCase()) && opt.parentId !== 0));


    const isOnlyRegionData = filterData.every((item) => typeof item.parentId === 'string' && (item.parentId.includes('Region')));
    const isOnlyInternationalLocations = filterData.every((item) => typeof item.parentId === 'string' && (item.parentId.includes('Region') || (item.parentId.includes('internationalLocations'))));

    if (isOnlyRegionData) {
      setCurrentSelectParent('Region');
    }

    if (isOnlyInternationalLocations) {
      setCurrentSelectParent('internationalLocations');
    }

    let sett = new Set()
    filterData.forEach((item: any) => {
      sett.add(item.parentId)
      sett.add(item.id)
      if (item?.grandParentId) {
        sett.add(item?.grandParentId)
      }

    })

    let updatedOptions = [...copyItemStates].filter((item: any) => sett.has(item.id))
    setItemStates([...updatedOptions])
    if (errorMessages?.jobLocation) {
      dispatch(setErrorMessages({ errorMessages: { jobLocation: '' } }));
    }
  }

  const clickHandler = useCallback((id: any, checked?: any) => {
    if (campaignId && !preloadedDataFilled) {
      setPreloadedDataFilled(true)
    }
    const [updatedItems, newPillData] = updateItemStates(itemStates, OPTIONS_LIST, id, pillData);
    if ((jobMode === 'Remote') || (newPillData.length > 5)) return;
    setPillData(newPillData)
    setInputValue('');

    let options = JSON.parse(JSON.stringify(copyItemStates))
    let checkedItems = updatedItems.filter((item: any) => item.isChecked);
    checkedItems = [...checkedItems, ...copyItemStates.filter((item: any) => item.isChecked)];


    let parentIds = checkedItems.map(item => item?.parentId);

    if (checkedItems && checkedItems.length > 0) {
      options = options.map((item: any) => {
        const isChecked = checkedItems.some((checkedItem: any) => item.id === checkedItem.id);
        const isSelectedParent = parentIds.some((parentId: any) => item.id === parentId && currentSelectedParent === parentId);

        if (isChecked) {
          // If the item is in checkedItems, set isChecked to true
          if (checked && id === item.id) {
            return { ...item, isChecked: false };
          }
          else {
            return { ...item, isChecked: true };
          }

        } else if (isSelectedParent && currentSelectedParent !== 'Region') {
          // If the item is in parentIds, increment the selected property
          if (checked) {
            return { ...item, selected: item.selected - 1 };
          }
          else {
            return { ...item, selected: item.selected + 1 };
          }
        } else {
          return item;
        }
      });
    }
    setItemStates(options)
    setCopyItemState(options);
    // setCurrentSelectParent('topCities');
    refInp.current.focus()
  }, [OPTIONS_LIST, copyItemStates, currentSelectedParent, itemStates, pillData]);


  const handlePillDelete = (pill: any) => {
    if (pillData.length === 1) { dispatch(setJobLocation({ jobLocation: [] })) };
    let updatedPillData = [...pillData]
    updatedPillData = updatedPillData.filter((pill: any) => pill.parentId !== pill.parentId)
    setPillData([...updatedPillData])
    if (pill?.id?.length === 1) {
      clickHandler(pill.id[0])
    }

    let options = JSON.parse(JSON.stringify(copyItemStates))
    const deletedItem = options.filter((item: any) => item.id === pill.id[0]);
    let parentId = deletedItem[0]?.parentId;

    if (deletedItem && deletedItem.length > 0) {
      options = options.map((item: any) => {
        if (item.id === deletedItem[0].id) {
          return { ...item, isChecked: false }
        }
        else if (item.id === parentId) {
          return { ...item, selected: item.selected - 1 }
        }
        else {
          return item;
        }
      })
    }

    setCopyItemState(options);
    setItemStates(options)
  }


  const handleClick = () => {
    setOpen(true);
  };

  const handleClickAway = () => {
    setOpen(false);
    setCurrentSelectParent('topCities');
  };

  const toggleLocationTypeMenu = () => {
    setLocationTypeMenu(!locationTypeMenu)
  }
  // const inputWidth = (pillData && pillData.length) ? '100%' : '0%';
  // const CustomStyledInputAdorment = StyledInputAdornment(inputWidth)

  const handleLocationTypeChange = (e: any) => {
    const locationTypeClicked = e?.target?.value;
    dispatch(setJobMode({ jobMode: locationTypeClicked }))
    dispatch(setErrorMessages({ errorMessages: { jobLocation: '' } }));
  }

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Box sx={{ position: 'relative', borderRadius: '4px', border: showError ? '1px solid red' : disableJobLocation ? 'none' : '1px solid #D2D1D6', background: '#FFF' }}>
          <Box sx={{ display: 'flex' }}>
            <Box sx={{
              width: '84px',
              textOverflow: 'inherit',
              color: '#59566C',
              background: '#F6F6F7',
              borderRadius: '4px 0 0 4px'
            }}>
              <SingleSelectDropDown
                handleChange={handleLocationTypeChange}
                id="locType"
                label="label"
                listItems={[
                  { label: 'WFO', additionalInfoHorizontal: '(Work from office) ', value: 'WFO' },
                  { label: 'Hybrid', value: 'Hybrid' },
                  { label: 'Remote', value: 'Remote' }
                ]}
                selectedValue={jobMode}
                MenuProps={{
                  PaperProps: {
                    style: {
                      minWidth: '171px',
                      marginTop: '2px'
                    }
                  },
                  anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left'
                  },
                  transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left'
                  },
                  MenuListProps: {
                    sx: {
                      '& .MuiMenuItem-root span': {
                        marginLeft: '4px !important',
                      },
                    },
                  },
                }}
                sx={{
                  "& fieldset": {
                    borderRight:'none'
                  },
                  "&.MuiInputBase-root": {
                    // padding: 0,
                    borderBottomRightRadius: '0 !important',
                    borderTopRightRadius: '0 !important',
                    width: '84px',
                  },
                  "& .MuiSelect-select": {
                    textOverflow: 'inherit !important'
                  }
                }}
              />
            </Box>

            <CommonTooltip 
              title={jobMode === 'Remote' ? 'Remote location has been selected' : disableJobLocation ? 'Search filters cannot be edited during campaign setup.' : ''}
              width='270px'
              customZIndex={99999999}
              offset={[0, 10]}
              >
              <Box sx={{ flex: 1, display: 'flex' }}>
                <TextField value={inputValue}
                  id="outlined-multiline-static"
                  onChange={(e) => handleInputChange(e.target.value)}
                  sx={{
                    paddingLeft: 0,
                    // "& fieldset": { border: 'none' },
                    "& fieldset": { borderLeft: 'none' },
                    "& .MuiInputAdornment-root": {
                      padding: 0
                    },
                    "& .MuiInputBase-root": {
                      overflowX: 'auto',
                      paddingLeft: '0.8rem',
                      borderRadius: '0 4px 4px 0',
                      borderLeft: '1px solid #D2D1D6',
                      scrollbarWidth: 'none' /* For Firefox */,
                      '&::-webkit-scrollbar': {
                        display: 'none' /* For Chrome, Safari, and Opera */,
                      },
                      "&.Mui-disabled": {
                        backgroundColor: '#F6F6F7'
                      }
                    },
                  }}
                  disabled={jobMode === 'Remote' || (disableJobLocation)}
                  onClick={() => {
                    if (disableJobLocation) return
                    handleClick()
                  }}
                  placeholder={(pillData && pillData.length) || jobMode === 'Remote' ? " " : "Select location"}
                  InputProps={{
                    startAdornment:
                      <StyledInputAdornment position="start">
                        {(jobMode !== 'Remote') && (
                          <SelectedLocations reference={refInp} data={pillData} handlePillDelete={handlePillDelete} disabled={disableJobLocation} />
                        )}
                      </StyledInputAdornment>,
                    inputProps: {
                      style: { cursor: jobMode === 'Remote' ? 'not-allowed' : 'pointer' }
                    }
                  }}
                  ref={refInp}
                  error={showError}
                // helperText={errorMessage}
                />
              </Box>
            </CommonTooltip>
          </Box>
        {open && <Tab
          itemsStates={itemStates}
          options={OPTIONS_LIST}
          onClick={clickHandler}
          isDisabled={isDisabled}
          // getStateForId={getStateForId}
          currentSelectedParent={currentSelectedParent}
          setCurrentSelectedParent={setCurrentSelectParent}
        // handleSelectAllItems={handleSelectAllItems}
        />}

      </Box>
    </ClickAwayListener>
  )
}


const Tab = (props: any) => {
  let { itemsStates,
    options,
    // getStateForId,
    onClick = () => { },
    currentSelectedParent,
    setCurrentSelectedParent,
    isDisabled,
    // handleSelectAllItems

  } = props


  const [showListHeader, setShowListHeader] = useState(false)
  const handleClick = (item: any, checked: any) => {

    onClick(item.id, !checked)
  }
  const handleOver = (item: any) => {
    if (item.next) {
      setCurrentSelectedParent(item.id)
    }
    if (item.parentId === 'Region') {
      setShowListHeader(true)
    }
    else {
      setShowListHeader(false)
    }

  }

  const parentItem = options.find((item: any) => item.id === currentSelectedParent)

  const isOnlyRegionData =
    itemsStates.slice(1).every((item: any) =>
      (typeof item.parentId === 'string') &&
      String(item.parentId).includes('Region')
    );


  let searchedRegion: any = null;
  // let firstMatchingRegionIndex: any = null

  if (isOnlyRegionData) {
    searchedRegion = itemsStates.filter((item: any) => typeof (item.id) === 'number')
  }

  // if(searchedRegion){
  //   firstMatchingRegionIndex =  options.findIndex((item: any) => searchedRegion.id === item.id);
  // }

  const matchedIdsSet = new Set();


  return (
    <Grid
      container
      border={`1px solid ${COLOR_MAP.GREY}`}
      position='absolute'
      borderRadius='0.4rem' style={{ backgroundColor: 'white', zIndex: '20' }}>
      <Grid item xs={6} borderRight={`2px solid ${COLOR_MAP.GREY}`}>
        <List sx={{
          padding: 0
        }}>
          {options.map((item: any) => (
            item.parentId === 0
            && itemsStates.findIndex((op: any) => op.id === item.id) > -1
            && <StyledParentListItems>
              <ListItemText
                onClick={() => handleOver(item)}
                primary={item.label + '(' + itemsStates.find((itemState: any) => itemState.id === item.id).selected + '/' + item.count + ')'} />
              <StyledIconButton disableRipple>< ArrowForwardIosIcon /> </StyledIconButton>
            </StyledParentListItems>
          ))}

        </List>

      </Grid>
      <Grid item xs={6} style={{ overflowY: 'scroll', }}>
        <List
          sx={{
            padding: 0
          }}
          subheader={
            showListHeader ?
              <Stack direction='row' sx={{ cursor: 'pointer' }} alignItems={'center'} padding={'12px 8px'} onClick={() => { setCurrentSelectedParent('Region'); setShowListHeader(false) }}>
                <IconButton disableRipple><ArrowBackIosIcon /> </IconButton>
                <ListSubheader sx={{
                  padding: '0',
                  lineHeight: '0',
                  fontFamily: 'Noto Sans',
                  fontSize: '12px',
                  fontWeight: '400',
                  letterSpacing: '0em',
                  textAlign: 'left',
                  color: `${COLOR_MAP.LIGHT_GREY}`
                }} component="div" id="nested-list-subheader">
                  {parentItem.label}
                </ListSubheader>
              </Stack> : null

          }>
          {searchedRegion ?
            options.map((item: any) => {
              const isIdMatched = searchedRegion.some((op: any) => op.id === item.id);
              if (isIdMatched && !matchedIdsSet.has(item.id)) {
                matchedIdsSet.add(item.id);
                return (
                  <ListItem key={item.id}>
                    <Checkbox
                      disableRipple
                      disabled={isDisabled && !itemsStates.find((itemState: any) => itemState.id === item.id).isChecked}
                      sx={{
                        'svg': {
                          color: (!isDisabled || itemsStates.find((itemState: any) => itemState.id === item.id).isChecked) ? COLOR_MAP.DARK_PURPLE : COLOR_MAP.DISABLED
                        }
                      }}
                      onClick={(event: any) => handleClick(item, event.target.checked)}
                      checked={itemsStates.find((itemState: any) => itemState.id === item.id).isChecked}
                    />
                    <ListItemText onClick={() => handleOver(item)} primary={item.label} />
                  </ListItem>
                );
              } else {
                return null;
              }
            })
            : options.map((item: any) => (
              item.parentId === currentSelectedParent
                && itemsStates.findIndex((op: any) => op.id === item.id) > -1
                ? (currentSelectedParent !== 'Region') ?
                  <ListItem >
                    <Checkbox
                      disableRipple
                      disabled={isDisabled && !itemsStates.find((itemState: any) => itemState.id === item.id).isChecked}
                      sx={{
                        'svg': {
                          color: (!isDisabled || itemsStates.find((itemState: any) => itemState.id === item.id).isChecked) ? COLOR_MAP.DARK_PURPLE : COLOR_MAP.DISABLED
                        }
                      }}
                      onClick={(event: any) => handleClick(item, event.target.checked)} checked={itemsStates.find((itemState: any) => itemState.id === item.id).isChecked} />
                    <ListItemText onClick={() => handleOver(item)} primary={item.count ? item.label + '(' + itemsStates.find((itemState: any) => itemState.id === item.id).selected + '/' + item.count + ')' : item.label} />
                  </ListItem>
                  :
                  <StyledParentListItems>
                    <ListItemText onClick={() => handleOver(item)} primary={item.label + '(' + itemsStates.find((itemState: any) => itemState.id === item.id).selected + '/' + item.count + ')'} />
                    <StyledIconButton disableRipple>< ArrowForwardIosIcon /> </StyledIconButton>
                  </StyledParentListItems>
                : null
            ))}

        </List>
      </Grid>
    </Grid>
  )
}

export default JobLocation